import { render, staticRenderFns } from "./EmpleadoPuestos.vue?vue&type=template&id=6270f4b5&"
import script from "./EmpleadoPuestos.vue?vue&type=script&lang=js&"
export * from "./EmpleadoPuestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports